import { render, staticRenderFns } from "./edit_survey.vue?vue&type=template&id=62c2163a"
import script from "./edit_survey.vue?vue&type=script&lang=js"
export * from "./edit_survey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports